<template>
  <div class="app-container" v-loading="loading">
    <span class="title">订单信息</span>
    <div class="content">
      <div>订单编号：{{ orderInfo.orderNum }}</div>
      <div>订单类型：{{ orderInfo.orderType }}</div>
      <div>下单时间：{{ orderInfoCreated | formatDateTimeDefault }}</div>
      <div v-if="completeTime" class="complete-time">完成时间：{{ completeTime | formatDateTimeDefault }}</div>
      <template v-for="item in cancelInfo">
        <div :key="item.id" v-if="item.feedbackType === 140">取消时间：{{ item.createdDate | formatDateTimeDefault }}</div>
      </template>
      <div>
        订单状态：
        <el-select v-model="orderInfo.orderState" placeholder="请选择" clearable v-if="!ifSmsOrder" :disabled="[3, 2].includes(originalOrderState)">
          <el-option v-for="item in orderStateList" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
            <!-- <el-option
            v-for="item in OrderStateTypeEnum"
            :key="item.enumCode"
            :label="item.description"
            :value="item.enumCode"
          > -->
          </el-option>
        </el-select>
        <span v-else>{{ orderInfo.orderStateStr }}</span>
      </div>
      <div>订单备注：{{ orderInfo.beiz }}</div>
      <div>订单来源：{{ filterSourceName(orderInfo) }}</div>
      <div v-if="orderInfo.userType === 2">
        <div>实际总数：{{ orderInfo.actualNums }}</div>
        <div>实际总价：{{ orderInfo.actualPrice ? orderInfo.actualPrice.toFixed(2) : '' }}</div>
        <div>下单总数：{{ orderInfo.nums }}</div>
        <div>下单总价：{{ orderInfo.money !== null ? orderInfo.money.toFixed(2) : '' }}</div>
      </div>
      <div v-if="orderInfo.cancelType">
        取消主体：{{ filterCancelType(orderInfo.cancelType)}}
      </div>
      <div v-if="orderInfo.cancelType">
        取消原因：{{ (orderInfo.cancelReason || "") }}
      </div>
      <div>
        客户申诉:
        <div v-for="item in orderComplaintList" :key="item.id">
          {{ item.createdDate + ' ' + item.complaintContent }}
        </div>
      </div>
      <div>
        申诉结果:
        <div v-for="item in orderFeedbackList" :key="item.id">
          {{ item.createdDate + ' ' + item.feedbackContent }}
        </div>
      </div>
      <div v-if="orderInfo.paymentMethod !== null && orderInfo.paymentMethod !== undefined && orderInfo.paymentMethod !== ''">
        支付方式: {{ filterPaymentMethod(orderInfo.paymentMethod) }}
      </div>
      <div v-if="orderInfo.otherReason">其他：{{ orderInfo.otherReason }}</div>
    </div>

    <span class="title">预约信息</span>
    <div class="content">
      <div>
        期望上门时间：{{ orderInfo.qwsmsj | formatDateTimeToShortString }}
        {{ orderInfo.expectedVisitTime }}
      </div>
      <div>
        用户电话：{{ phoneDetail.phone }}
        <span v-if="phoneDetail">
          <img v-if="!dataVisible.phone" src="@/assets/eye-close.png" @click="togglePhoneVisibility('phone')" />
          <img v-else src="@/assets/eye-open.png" @click="togglePhoneVisibility('phone')" />
        </span>
      </div>
      <div>联系人名称：{{ orderInfo.yhmc }}</div>
      <div>
        联系人电话：{{ orderInfo.yddh }}
        <span v-if="orderInfo.yddh">
          <img v-if="!dataVisible.yddhPhone" src="@/assets/eye-close.png" @click="togglePhoneVisibility('yddhPhone')" />
          <img v-else src="@/assets/eye-open.png" @click="togglePhoneVisibility('yddhPhone')" />
        </span>
      </div>
      <div>
        回收地址：{{ address
        }}<span v-if="address">
          <img v-if="!dataVisible.dizi" src="@/assets/eye-close.png" @click="togglePhoneVisibility('dizi')" />
          <img v-else src="@/assets/eye-open.png" @click="togglePhoneVisibility('dizi')" />
        </span>
      </div>
      <div v-if="!ifBusinessOrder">楼层：{{ orderInfo.floor }}</div>
      <div v-if="ifSmsOrder">是否拆机：{{ orderInfo.dismantle }}</div>
      <div v-if="ifBusinessOrder">是否上门：{{ orderInfo.dismantle }}</div>

      <div>操作预约时间：{{ orderInfo.setAppointmentTime | formatDateTimeDefault }}</div>
      <div>
        首次预约日期：{{ orderInfo.appointmentTime | formatDateTimeDefault
        }}<span v-if="orderInfo.appointmentEndTime"> ～ {{ orderInfo.appointmentEndTime | formatDateTimeDefault }}</span>
      </div>
      <div>
        最新预约日期：{{ orderInfo.lastAppointmentTime | formatDateTimeDefault}} <span v-if="orderInfo.lastAppointmentEndTime">～ {{ orderInfo.lastAppointmentEndTime | formatDateTimeDefault }}</span>
      </div>
    </div>

    <span class="title">回收信息</span>
    <div class="content">
      <!--      <div>网点分配时间：{{outletAllocationTime | formatDateTimeDefault}}</div>-->
      <!--      <div>网点名称：{{fkwdno + ' ' + fkwdmc}}</div>-->
      <!--      <div>网点联系电话：{{wdphone}}</div>-->
      <!--      <div>回收员分配时间：{{ recyclerAllocationTime | formatDateTimeDefault}}</div>-->
      <!--      <div>回收员名称：{{ fkren + ' ' + fkrenmc }}</div>-->
      <!--      <div>回收员电话：{{ wxgphone }}</div>-->
      <div>合作方类型：{{ partnershipTypeStr }}</div>
      <div>合作方名称：{{ partnerName }}</div>
      <div>回收人员姓名：{{ tblRecycleWorkOrder && tblRecycleWorkOrder.length > 0 ? tblRecycleWorkOrder[0].recycleRenName : '' }}</div>
      <div>
        回收人员电话：{{ tblRecycleWorkOrder && tblRecycleWorkOrder.length > 0 ? tblRecycleWorkOrder[0].recycleRenPhone : '' }}
        <span v-if="tblRecycleWorkOrder && tblRecycleWorkOrder.length > 0">
          <img v-if="!dataVisible.recycleRenPhone" src="@/assets/eye-close.png" @click="togglePhoneVisibility('recycleRenPhone')" />
          <img v-else src="@/assets/eye-open.png" @click="togglePhoneVisibility('recycleRenPhone')" />
        </span>
      </div>
      <div class="row-flex" v-if="orderInfo.orderState !== 2 || productImageBase64 || productImageSideBase64 || indoorUnitWallPhotoBase64 || outdoorUnitPhotoBase64 || fullOldUnitPhotoBase64 || oldUnitNameplatePhotoBase64 || recyclingCertificateBase64">
        旧机图片：
        <div style="display: flex; flex-wrap: wrap; gap: 10px; align-items: flex-start;">
          <!-- 基础图片：非完成状态可编辑，完成状态仅在有图时显示 -->
          <template v-if="orderInfo.orderState !== 2 || productImageBase64 || productImageSideBase64">
            <image-upload :imageUrl="productImageBase64" :editMode="orderInfo.orderState !== 2" @success="uploadSuccess($event, 'productImage')" :isHttp="!!productImageBase64" :maxSize="5" />
            <image-upload :imageUrl="productImageSideBase64" :editMode="orderInfo.orderState !== 2" @success="uploadSuccess($event, 'productImageSide')" :isHttp="!!productImageSideBase64" :maxSize="5" />
          </template>

          <!-- 完工后的线下回收照片：仅在有图时显示 -->
          <template v-if="orderInfo.orderState == 2">
            <image-upload v-if="indoorUnitWallPhotoBase64" :imageUrl="indoorUnitWallPhotoBase64" :editMode="false" :isHttp="true" :maxSize="5" />
            <image-upload v-if="outdoorUnitPhotoBase64" :imageUrl="outdoorUnitPhotoBase64" :editMode="false" :isHttp="true" :maxSize="5" />
            <image-upload v-if="fullOldUnitPhotoBase64" :imageUrl="fullOldUnitPhotoBase64" :editMode="false" :isHttp="true" :maxSize="5" />
            <image-upload v-if="oldUnitNameplatePhotoBase64" :imageUrl="oldUnitNameplatePhotoBase64" :editMode="false" :isHttp="true" :maxSize="5" />
            <image-upload v-if="recyclingCertificateBase64" :imageUrl="recyclingCertificateBase64" :editMode="false" :isHttp="true" :maxSize="5" />
          </template>
        </div>
      </div>

      <div class="row-flex">
        支付凭证：
        <image-upload
          v-if="orderInfo.paymentReceiptImage"
          :imageUrl="paymentReceiptImageBase64"
          :editMode="false"
          @success="uploadSuccess($event, 'paymentReceiptImage')"
          :isHttp="!!paymentReceiptImageBase64"
        />
      </div>
    </div>

    <span class="title">推荐信息</span>
    <div class="content">
      <div>平台抽成：{{ orderInfo.platformCommission }}</div>
      <div>推荐类型：{{ filterRecommendType(orderInfo.referralType) }}</div>
      <div>推荐人：{{ orderInfo.referralPerson }}</div>
      <div>手机号：{{ orderInfo.referralPhone }}</div>
      <div>推荐奖励：{{ orderInfo.referralBonus }}</div>
    </div>

    <template v-if="ifSmsOrder">
      <span class="title">工单信息</span>
      <div class="content">
        <div>工单状态：{{ orderState[workOrder.workStat] }}</div>
        <div>网点名称：{{ workOrder.wdmc }}</div>
        <div>网点联系电话：{{ wdphone }}</div>
        <div>回收员名称：{{ workOrder.recycleRenName }}</div>
        <div>回收员电话：{{ workOrder.recycleRenPhone }}</div>
        <div>预约上门时间：{{ workOrder.yysmsj }}</div>
      </div>
    </template>

    <span class="title">评价信息</span>
    <div class="content">
      <div>服务态度：{{ eval.serviceAttitudeRating }}</div>
      <div>服务时效：{{ eval.serviceEfficiencyRating }}</div>
      <div>服务规范：{{ eval.serviceStandardRating }}</div>
      <div>评价内容：{{ eval.serviceEval }}</div>
    </div>

    <div v-if="!ifBusinessOrder">
      <span class="title">商品列表</span>
      <!-- <div class="button-row" v-if="!ifSmsOrder">
           <el-button @click="addRow" type="text" size="small">添加商品</el-button>
         </div> -->
      <div class="table">
        <el-table :data="goodLists" style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="spmc" label="品类" width="150"></el-table-column>
          <el-table-column prop="standards" label="规格" width="320"></el-table-column>
          <!-- <el-table-column prop="barcodes" label="回收条码" width="250"></el-table-column> -->
          <template v-if="orderInfo.userType === 2">
            <el-table-column prop="number" label="下单品类数量" width="100"></el-table-column>
            <el-table-column prop="actualNumber" label="实际品类数量" width="100"></el-table-column>
            <el-table-column prop="price" label="下单品类金额" width="100"></el-table-column>
            <el-table-column prop="actualPrice" label="实际品类金额" width="100"></el-table-column>

            <el-table-column prop="unitStr" label="单位" width="100"></el-table-column>
            <el-table-column prop="weight" label="称重数量" width="100"></el-table-column>
          </template>
          <!-- <el-table-column width="100" v-if="!ifSmsOrder">
                   <template slot-scope="scope">
                     <el-link type="danger" @click="removeRow(scope.row)">删除</el-link>
                   </template>
                 </el-table-column> -->
        </el-table>
      </div>
    </div>
    <div v-else>
      <div v-if="[1, 3].includes(orderInfo.orderState)">
        <span class="title">下单商品信息</span>
        <div class="table" style="margin-bottom: 20px">
          <el-table :data="goodLists" style="width: 100%">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="spmc" label="品类" width="100"></el-table-column>
            <el-table-column prop="specs" label="规格" width="150"></el-table-column>
            <el-table-column prop="xhmc" label="型号" width="150"></el-table-column>
            <el-table-column prop="number" label="数量" width="100"></el-table-column>
            <el-table-column prop="price" label="金额" width="100">
              <template slot-scope="scope">
                {{ scope.row.price * scope.row.number }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-else>
        <span class="title">实际商品信息</span>
        <div class="table">
          <el-table :data="goodLists" style="width: 100%">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="spmc" label="品类" width="100"></el-table-column>
            <el-table-column prop="specs" label="规格" width="150"></el-table-column>
            <el-table-column prop="xhmc" label="型号" width="150"></el-table-column>
            <el-table-column prop="brandStr" label="品牌" width="150"></el-table-column>
            <el-table-column prop="pipeStr" label="是否含管" width="150"></el-table-column>
            <el-table-column prop="paneStr" label="单双片" width="150"></el-table-column>
            <el-table-column prop="ageStr" label="年限" width="150"></el-table-column>
            <el-table-column prop="actualNumber" label="数量" width="150"></el-table-column>
            <el-table-column prop="actualPrice" label="金额" width="150"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <template>
      <span class="title">实收商品列表</span>
      <div class="table">
        <el-table :data="actualGoodLists" style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="spmc" label="品类" width="150"></el-table-column>
          <el-table-column prop="standards" label="规格" width="320"></el-table-column>
        </el-table>
      </div>
    </template>
    <div class="content" v-if="!ifBusinessOrder">
      <div>估价：{{ orderInfo.money }}</div>
      <div>实际回收价格：{{ orderInfo.actualPrice || '--' }}</div>
    </div>
    <div class="btnBack m-t-15">
      <el-button type="primary" @click="submit()" v-if="![3, 2].includes(originalOrderState)">确认</el-button>
      <!-- 用户下单 -->
      <el-button
        v-if="$route.query.type === 'userOrder'"
        type="primary"
        @click="
          $router.push({
            path: '/order/orderGet',
            query: { params: $route.query.params }
          })
        "
      >
        返回
      </el-button>
      <!-- 批量下单 -->
      <el-button
        v-if="$route.query.type === 'batchOrder'"
        type="primary"
        @click="
          $router.push({
            path: '/order/batchOrderGet',
            query: { params: $route.query.params }
          })
        "
        >返回
      </el-button>
      <el-button
        v-if="$route.query.type === 'billDetail'"
        type="primary"
        @click="
          $router.push({
            path: '/paymentManagement/billDetailsSearch',
            query: { params: $route.query.params }
          })
        "
        >返回
      </el-button>
    </div>

    <el-dialog title="添加商品" :visible.sync="dialogFormVisible" width="500px" v-loading="loading">
      <div class="dialog-body">
        <el-form :model="form">
          <el-form-item label="品类" label-width="80px">
            <el-select v-model="form.spid" placeholder="请选择品类" @change="changeSplb">
              <el-option v-for="item in tblSplbDalei" :label="item.spmc" :value="item.spid" :key="item.spid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" label-width="80px">
            <el-select v-model="form.brandNum" placeholder="请选择品牌">
              <el-option v-for="item in tblSplbBrand" :label="item.brandName" :value="item.brandNum" :key="item.brandNum"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机型" label-width="80px">
            <el-select v-model="form.xlid" placeholder="请选择机型" @change="changeSpxl">
              <el-option v-for="item in tblSplbXiaolei" :label="item.xlmc" :value="item.xlid" :key="item.xlid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="typeLabel[form.spid]" label-width="80px" v-if="[101, 102, 104, 106].includes(form.spid)">
            <el-select v-model="form.xhno" placeholder="请选择型号">
              <el-option v-for="item in tblSplbJixin" :label="item.xhmc" :value="item.xhno" :key="item.xhno"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelAddRow()">取 消</el-button>
        <el-button type="primary" @click="confirmAddRow()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { re } from 'semver'
import imageUpload from '@/components/Upload/ImageUpload'
import enumMixin from './enumMixin.js'
import dayjs from 'dayjs'
export default {
  mixins: [enumMixin],
  data() {
    return {
      aa: 'https://sms4.sms-test.gree.com/sms/img/login_logo.5fb7ff48.png',
      ifSmsOrder: false, //是否是sms回传工单
      ifBusinessOrder: false, //是否是企业订单
      dialogFormVisible: false, //添加产品弹框
      loading: false,

      completeTime: '', // 完成时间
      cancellationTime: '', //取消时间
      recyclerAllocationTime: '', //回收员分配时间
      outletAllocationTime: '', //网点分配时间
      wdphone: '', // 网点电话
      wxgphone: '', // 回收员电话
      fkren: '', // 分配工程师编号
      fkrenmc: '', // 分配工程师名称
      fkwdmc: '', // 分配网点名称
      fkwdno: '', // 分配网点编号

      orderInfo: {}, //小格绿订单信息
      originalOrderState: null, // 原始订单状态
      productImageBase64: '',
      productImageSideBase64: '',
      indoorUnitWallPhotoBase64: '',
      outdoorUnitPhotoBase64: '',
      fullOldUnitPhotoBase64: '',
      oldUnitNameplatePhotoBase64: '',
      recyclingCertificateBase64: '',
      paymentReceiptImageBase64: '',

      phoneDetail: {}, //用户电话
      workOrder: {}, //工单信息
      tblRecycleWorkOrder: [], //工单信息copy，暂存用
      orderStateList: [
        {
          label: '待派单',
          value: -1
        },
        {
          label: '待预约',
          value: 0
        },
        {
          label: '待取件',
          value: 1
        },
        { label: '已取件', value: 101 },
        { label: '待提现', value: 102 },
        { label: '提现中', value: 103 },
        {
          label: '已取消',
          value: 3
        },
        {
          label: '已完成',
          value: 2
        },
        {
          label: '已估价',
          value: 4
        }
      ], //小格绿订单状态
      goodLists: [], //商品列表
      actualGoodLists: [], //实收商品列表
      form: {
        spmc: '',
        spid: '',
        brandName: '',
        brandNum: '',
        xlmc: '',
        xlid: '',
        xhmc: '',
        xhno: ''
      }, //新增商品信息
      typeLabel: {
        101: '功率',
        102: '尺寸',
        104: '完整程度',
        106: '容积'
      }, //规格label
      orderState: {
        1000: '保存',
        1010: '待分部派工',
        1020: '待分中心派工',
        1030: '待网点派工',
        1040: '待审批改派',
        1050: '待服务人员处理',
        1060: '服务人员报完工',
        1070: '已作废工单',
        1080: '正常关闭'
      }, //sms工单状态

      tblSplbDalei: [], //大类列表
      tblSplbBrand: [], //品牌列表
      tblSplbXiaolei: [], //小类列表
      tblSplbJixin: [], //机型列表
      eval: {},
      partnerName: '',
      partnershipTypeStr: '',
      orderComplaintList: '',
      orderFeedbackList: '',
      cancelInfo: [],
      orderInfoCreated: '',
      desensitizationDtoList: [],
      yddhPhone: {},
      recycleRenPhone: {},
      dizi: {},
      dataVisible: {
        phone: false,
        yddhPhone: false,
        recycleRenPhone: false,
        dizi: false
      },
      phone: '',
      originInfo: {},
      copytblRecyleWorkOrder: [],
      originPhone: '',
      address: ''
    }
  },
  components: { imageUpload },
  created() {
    this.getList()
    const partnershipType = JSON.parse(localStorage.getItem('partnershipType'))

    if (partnershipType === 2) {
      this.orderStateList = [
        { label: '待派单', value: -1, disabled: true },
        { label: '待预约', value: 0, disabled: true },
        { label: '待取件', value: 1, disabled: true },
        { label: '已取件', value: 101, disabled: true },
        { label: '待提现', value: 102, disabled: true },
        { label: '提现中', value: 103, disabled: true },
        { label: '已完成', value: 2, disabled: true },
        { label: '已取消', value: 3, disabled: false },
        { label: '已估价', value: 4, disabled: true }
      ]
    } else {
      this.orderStateList = [
        { label: '待派单', value: -1, disabled: true },
        { label: '待预约', value: 0, disabled: true },
        { label: '已取件', value: 101, disabled: true },
        { label: '待提现', value: 102, disabled: true },
        { label: '提现中', value: 103, disabled: true },
        { label: '待取件', value: 1, disabled: false },
        { label: '已取消', value: 3, disabled: false },
        { label: '已完成', value: 2, disabled: false },
        { label: '已估价', value: 4, disabled: false }
      ]
    }
    if (this.$route.query.type === 'batchOrder') {
      this.orderStateList = this.orderStateList.filter(item => item.value !== -1 && item.value !== 0)
    }
  },
  methods: {
    filterPaymentMethod(val) {
      if (val === 0) return '线下支付'
      if (val === 1) return '线上支付'
      return ''
    },
    //初始化
    getList() {
      this.HttpService.get(`/autoapp-default-server-recovery/api/tblRecycleOrder/getUserById/${this.$route.query.id}`).then(res => {
        // 添加空值检查，防止 Cannot read properties of null 错误
        if (!res || !res.data) {
          this.$message.error('获取订单信息失败')
          return
        }

        this.orderInfo = res.data.tblRecycleOrder || {}
        this.address = [this.orderInfo.sfen, this.orderInfo.cshi, this.orderInfo.xian, this.orderInfo.xzhen, this.orderInfo.mapAddress, this.orderInfo.dizi]
          .filter(Boolean)
          .join('')
        this.originInfo = res.data.tblRecycleOrder ? { ...res.data.tblRecycleOrder } : {}
        this.orderInfoCreated = res.data.tblRecycleOrder ? res.data.tblRecycleOrder.createdDate : ''
        this.cancelInfo = res.data.recycleFeedbackList || []
        this.originalOrderState = res.data.tblRecycleOrder ? res.data.tblRecycleOrder.orderState : null // 保存原始订单状态
        this.orderComplaintList = res.data.orderComplaintList
        this.orderFeedbackList = res.data.orderFeedbackList
        this.desensitizationDtoList = res.data.desensitizationDtoList

        // 根据 sensitizationCode 拆分数据
        if (res.data.desensitizationDtoList && Array.isArray(res.data.desensitizationDtoList)) {
          const phoneMappings = {
            yddh_phone: 'yddhPhone',
            recycleRenPhone_phone: 'recycleRenPhone',
            dizi_address: 'dizi'
          }

          res.data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
        let indexVal1 = 0
        let indexVal2 = 0

        if (this.orderInfo.paymentReceiptImage) {
          indexVal1 = this.orderInfo.paymentReceiptImage.indexOf('http')
        }
        if (this.orderInfo.productImage) {
          indexVal2 = this.orderInfo.productImage.indexOf('http')
        }
        if (this.orderInfo.productImageSide) {
          if (this.orderInfo.productImageSide.indexOf('http') != -1) {
            this.transImgUrl(this.orderInfo.productImageSide, 'productImageSideBase64')
          } else {
            this.handleImgUrl(this.orderInfo.productImageSide, 'productImageSideBase64')
          }
        }

        if (indexVal1 !== -1 && indexVal2 !== -1) {
          // 转换地址
          this.transImgUrl(this.orderInfo.productImage, 'productImageBase64')
          this.transImgUrl(this.orderInfo.paymentReceiptImage, 'paymentReceiptImageBase64')
        } else {
          this.handleImgUrl(this.orderInfo.productImage, 'productImageBase64')
          this.handleImgUrl(this.orderInfo.paymentReceiptImage, 'paymentReceiptImageBase64')
        }

        // 处理 tblSelfRecycleOrderFile 中的五张图片
        if (res.data.tblSelfRecycleOrderFile) {
          const fileData = res.data.tblSelfRecycleOrderFile
          const photoFields = [
            { field: 'indoorUnitWallPhoto', target: 'indoorUnitWallPhotoBase64' },
            { field: 'outdoorUnitPhoto', target: 'outdoorUnitPhotoBase64' },
            { field: 'fullOldUnitPhoto', target: 'fullOldUnitPhotoBase64' },
            { field: 'oldUnitNameplatePhoto', target: 'oldUnitNameplatePhotoBase64' },
            { field: 'recyclingCertificate', target: 'recyclingCertificateBase64' }
          ]

          photoFields.forEach(item => {
            const imgUrl = fileData[item.field]
            if (imgUrl) {
              if (imgUrl.startsWith('data:image') || imgUrl.length > 500) {
                // 如果是 base64 格式
                const base64Str = imgUrl.startsWith('data:image') ? imgUrl : `data:image/jpeg;base64,${imgUrl}`
                this.$set(this, item.target, base64Str)
              } else if (imgUrl.indexOf('http') !== -1) {
                // 如果是 http 链接
                this.transImgUrl(imgUrl, item.target)
              } else {
                // 如果是 OSS objectName
                this.handleImgUrl(imgUrl, item.target)
              }
            }
          })
        }

        // 取消原因
        res.data.tblRecycleCancelledOrderLogs.length && Object.assign(this.orderInfo, res.data.tblRecycleCancelledOrderLogs[0])
        //判断是否是sms回传订单
        this.ifSmsOrder = this.orderInfo.isPushSms == 1 ? true : false
        //判断是否是企业订单
        this.ifBusinessOrder = this.orderInfo.orderType == '网点订单' ? true : false
        this.tblRecycleWorkOrder = res.data.tblRecycleWorkOrder
        this.copytblRecyleWorkOrder = res.data.tblRecycleWorkOrder ? JSON.parse(JSON.stringify(res.data.tblRecycleWorkOrder)) : []
        this.partnerName = res.data.partnerName
        this.partnershipTypeStr = res.data.partnershipTypeStr
        // 工单信息
        if (res.data.tblRecycleWorkOrder && res.data.tblRecycleWorkOrder.length) {
          this.workOrder = res.data.tblRecycleWorkOrder[0] || {}
        }
        // 商品列表
        this.goodLists = res.data.recycleCommodityDtos.map(item => this.processData(item))
        // 实收商品列表：品类取商品列表的品类，规格由订单实际型号、规格组合而成
        this.actualGoodLists = this.goodLists.map(item => ({
          spmc: item.spmc,
          standards: this.formatActualStandards()
        }))
        this.getUserPhone(this.orderInfo.userId)
        // 评价
        if (res.data.tblRecycleOrderServiceEvals && res.data.tblRecycleOrderServiceEvals.length) {
          this.eval = res.data.tblRecycleOrderServiceEvals[0] || {}
        }
        if (this.ifSmsOrder == true) {
          this.orderStateList.forEach(item => {
            if (item.value == this.orderInfo.orderState) {
              this.orderInfo.orderStateStr = item.label
            }
          })
        }

        // 通过反馈信息数据 获取分配时间，完成时间，取消时间
        let assignFkmxes = res.data.tblRecycleAssignFkmxes
        for (let i = 0; i < assignFkmxes.length; i++) {
          if (assignFkmxes[i].fkjg == '自动派工' || assignFkmxes[i].fkjg == '指派网点') {
            // 网点分配时间
            this.outletAllocationTime = assignFkmxes[i].fksj
            this.fkwdmc = assignFkmxes[i].fkwdmc
            this.fkwdno = assignFkmxes[i].fkwdno
          } else if (assignFkmxes[i].fkjg == '指派工程师') {
            // 回收员分配时间
            this.recyclerAllocationTime = assignFkmxes[i].fksj
            this.fkren = assignFkmxes[i].fkren
            this.fkrenmc = assignFkmxes[i].fkrenmc
          } else if (assignFkmxes[i].fkjg == '服务人员报完工' || assignFkmxes[i].fkjg == '已完成') {
            // 完成时间
            this.completeTime = assignFkmxes[i].fksj
            this.fkren = assignFkmxes[i].fkren
            this.fkrenmc = assignFkmxes[i].fkrenmc
          } else if (assignFkmxes[i].fkjg == '已取消') {
            // 取消时间
            this.cancellationTime = assignFkmxes[i].fksj
          }

          // 如果反馈记录中有号码则使用记录中的号码
          if (assignFkmxes[i].fkwdphone) {
            // 网点电话
            this.wdphone = assignFkmxes[i].fkwdphone
          }
          if (assignFkmxes[i].fkwxgphone) {
            // 工人电话
            this.wxgphone = assignFkmxes[i].fkwxgphone
          }
        }
      })
    },

    getUserPhone(id) {
      if (!id) {
        return
      }
      this.HttpService.get(`/autoapp-recovery-server-auth/api/recoveryUser/getUserPhoneById/${id}`).then(res => {
        if (res.statusCode === 200) {
          this.phoneDetail = res.data
          this.originPhone = res.data ? { ...res.data } : {}

          // 根据 sensitizationCode 拆分数据
          if (res.data.deSensitizationDtoList && Array.isArray(res.data.deSensitizationDtoList)) {
            const phoneMappings = {
              phone_phone: 'phone'
            }

            res.data.deSensitizationDtoList.forEach(item => {
              const targetProperty = phoneMappings[item.sensitizationCode]
              if (targetProperty) {
                this[targetProperty] = {
                  sensitizationCode: item.sensitizationCode,
                  message: item.message
                }
              }
            })
          }
        }
      })
    },
    async submit() {
      //已完成状态旧机图片必传
      if (this.orderInfo.orderState == 2) {
        if (!this.orderInfo.productImage || !this.orderInfo.productImageSide) {
          this.$message.warning('请上传两张旧机图片')
          return
        }
      }

      // 显示全局加载状态
      this.loading = true

      // 复制原始数据以避免修改源数据
      let tblRecycleOrder = JSON.parse(JSON.stringify(this.orderInfo))
      let tblRecycleWorkOrder = JSON.parse(JSON.stringify(this.tblRecycleWorkOrder))

      // 解密所有敏感字段
      try {
        // 解密用户手机号
        if (this.phone.message && this.phoneDetail.phone) {
          const decryptedPhone = await this.getSourceOrigin(this.phone)
          this.$set(this.phoneDetail, 'phone', decryptedPhone)
        }

        // 解密预约电话
        if (this.yddhPhone.message && this.yddhPhone.sensitizationCode) {
          const decryptedYddh = await this.getSourceOrigin(this.yddhPhone)
          this.$set(tblRecycleOrder, 'yddh', decryptedYddh)
        }

        // 解密回收人电话
        if (this.recycleRenPhone.message && this.recycleRenPhone.sensitizationCode && tblRecycleWorkOrder.length > 0) {
          const decryptedRecyclePhone = await this.getSourceOrigin(this.recycleRenPhone)
          this.$set(tblRecycleWorkOrder[0], 'recycleRenPhone', decryptedRecyclePhone)
        }

        // 解密地址
        if (this.dizi.message && this.dizi.sensitizationCode) {
          const decryptedDizi = await this.getSourceOrigin(this.dizi)
          this.$set(tblRecycleOrder, 'dizi', decryptedDizi)
        }
      } catch (error) {
        console.error('解密失败:', error)
        this.$message.error('数据处理失败，请重试')
        this.loading = false
        return
      }

      let params = {
        tblRecycleOrder: tblRecycleOrder,
        tblRecycleWorkOrder: tblRecycleWorkOrder,
        recycleCommodityDtos: this.goodLists
      }

      this.global.confirm('是否确认修改', () => {
        this.HttpService.post(`/autoapp-default-server-recovery/api/tblRecycleOrder/saveOrder`, params)
          .then(res => {
            if (res.statusCode == 200) {
              this.$message.success('修改成功')
              this.getList() //刷新页面
            } else {
              this.$message.error(res.message)
            }
          })
          .finally(() => {
            // 隐藏全局加载状态
            this.loading = false
          })
      })
    },
    //获取商品大类（品类）
    getTblSplbDalei() {
      return new Promise((resolve, reject) => {
        let params = {
          flag: '1'
        }
        this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei?flag=1`, params).then(res => {
          if (res.statusCode == 200) {
            this.tblSplbDalei = res.data
            this.$set(this.form, 'spid', res.data[0].spid)
            this.$set(this.form, 'spmc', res.data[0].spmc)
            resolve()
          }
        })
      })
    },
    //获取品牌
    getTblSplbBrand() {
      return new Promise((resolve, reject) => {
        let params = {
          flag: '1'
        }
        this.HttpService.get(`/autoapp-default-server-recovery/api/tblSplbBrand/getTblSplbBrand?flag=1`, params).then(res => {
          if (res.statusCode == 200) {
            this.tblSplbBrand = res.data
            this.$set(this.form, 'brandNum', res.data[0].brandNum)
            this.$set(this.form, 'brandName', res.data[0].brandName)
            resolve()
          }
        })
      })
    },
    //获取商品小类（规格）
    getTblSplbXiaolei() {
      let params = {
        flag: '1',
        spid: this.form.spid
      }
      return new Promise((resolve, reject) => {
        this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-splb-xiaolei/getTblSplbXiaolei?flag=1&spid=${this.form.spid}`, params).then(res => {
          if (res.statusCode == 200) {
            this.tblSplbXiaolei = res.data
            this.$set(this.form, 'xlid', res.data[0].xlid)
            this.$set(this.form, 'goodsNorms', res.data[0].xlmc)
            resolve()
          }
        })
      })
    },
    //获取商品型号
    getTblSplbJixin() {
      let params = {
        flag: '1',
        spid: this.form.spid,
        xlid: this.form.xlid
      }
      return new Promise((resolve, reject) => {
        this.HttpService.get(`/autoapp-default-server-recovery/api/tbl-splb-jixin/getTblSplbJixin?flag=1&spid=${this.form.spid}&xlid=${this.form.xlid}`, params).then(res => {
          if (res.statusCode == 200) {
            this.tblSplbJixin = res.data
            this.$set(this.form, 'xhno', res.data[0].xhno)
            this.$set(this.form, 'model', res.data[0].xhmc)
            resolve()
          }
        })
      })
    },
    //获取商品大类名
    getSpmcById(spid) {
      let spmc = ''
      this.tblSplbDalei.forEach(item => {
        if (item.spid == spid) {
          spmc = item.spmc
        }
      })
      return spmc
    },
    //获取商品品牌
    getSpBrandById(brandNum) {
      let brandName = ''
      this.tblSplbBrand.forEach(item => {
        if (item.brandNum == brandNum) {
          brandName = item.brandName
        }
      })
      return brandName
    },
    //获取商品小类名
    getXlmcById(xlid) {
      let xlmc = ''
      this.tblSplbXiaolei.forEach(item => {
        if (item.xlid == xlid) {
          xlmc = item.xlmc
        }
      })
      return xlmc
    },
    //获取商品型号
    getXhmcById(xhno) {
      let xhmc = ''
      this.tblSplbJixin.forEach(item => {
        if (item.xhno == xhno) {
          xhmc = item.xhmc
        }
      })
      return xhmc
    },

    async addRow() {
      await this.getTblSplbDalei()
      await this.getTblSplbBrand()
      await this.getTblSplbXiaolei()
      await this.getTblSplbJixin()
      this.dialogFormVisible = true
    },
    confirmAddRow() {
      //品牌
      let goodsBrand = {
        standardsKey: 'brandNum',
        standardsValue: this.form.brandNum
      }
      let goodsBrandName = {
        standardsKey: 'brandName',
        standardsValue: this.getSpBrandById(this.form.brandNum)
      }
      //规格
      let spxl = {
        standardsKey: 'xlid',
        standardsValue: this.form.xlid
      }
      let spxlName = {
        standardsKey: 'xlmc',
        standardsValue: this.getXlmcById(this.form.xlid)
      }
      //型号
      let spxh = {
        standardsKey: 'xhno',
        standardsValue: this.form.xhno
      }
      let spxhName = {
        standardsKey: 'xhmc',
        standardsValue: this.getXhmcById(this.form.xhno)
      }
      let tblRecycleStandards = []
      tblRecycleStandards.unshift(goodsBrand)
      tblRecycleStandards.unshift(goodsBrandName)
      tblRecycleStandards.unshift(spxl)
      tblRecycleStandards.unshift(spxlName)
      if ([101, 102, 104, 106].includes(this.form.spid)) {
        tblRecycleStandards.unshift(spxh)
        tblRecycleStandards.unshift(spxhName)
      }
      let rowData = {
        tblRecycleBarcode: [],
        tblRecycleCommodity: {
          spid: this.form.spid,
          spmc: this.form.spmc
        },
        tblRecycleStandards: tblRecycleStandards
      }
      this.goodLists.push(this.processData(rowData))
      console.log('this.goodLists', this.goodLists)
      this.cancelAddRow()
    },
    cancelAddRow() {
      this.form = {
        spmc: '',
        spid: '',
        brandName: '',
        brandNum: '',
        xlmc: '',
        xlid: '',
        xhmc: '',
        xhno: ''
      }
      this.dialogFormVisible = false
    },
    async changeSplb(e) {
      this.$set(this.form, 'spmc', this.getSpmcById(e))
      this.loading = true
      await this.getTblSplbXiaolei()
      await this.getTblSplbJixin()
      this.loading = false
    },
    async changeSpxl() {
      this.loading = true
      await this.getTblSplbJixin()
      this.loading = false
    },
    removeRow(row) {
      if (this.goodLists.length <= 1) {
        this.$message({
          type: 'warning',
          message: '商品列表不能为空!'
        })
        return
      }
      this.$confirm('确认删除该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        this.goodLists = this.goodLists.filter(item => {
          return item != row
        })
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      })
    },
    //处理商品列表数据
    processData(item) {
      //解析品类字段 spmc
      item.spmc = item.tblRecycleCommodity.spmc
      item.number = item.tblRecycleCommodity.number //下单品类数量
      item.actualNumber = item.tblRecycleCommodity.actualNumber //实际品类数量
      item.price = item.tblRecycleCommodity.price //下单品类金额
      item.actualPrice = item.tblRecycleCommodity.actualPrice //实际品类金额
      item.unitStr = item.tblRecycleCommodity.unitStr
      item.weight = item.tblRecycleCommodity.weight
      item.brandStr = item.tblRecycleCommodity.brandStr
      item.pipeStr = item.tblRecycleCommodity.pipeStr
      item.paneStr = item.tblRecycleCommodity.paneStr
      item.ageStr = item.tblRecycleCommodity.ageStr

      // 新增回显，品牌：不涉及；是否含管：不涉及；单双片：不涉及；年限：1-3年；
      const { brandStr, pipeStr, paneStr, ageStr } = item.tblRecycleCommodity
      let addStandards = ''
      if (brandStr) {
        addStandards += `品牌：${brandStr}；`
      }
      if (pipeStr) {
        addStandards += `是否含管：${pipeStr}；`
      }
      if (paneStr) {
        addStandards += `单双片：${paneStr}；`
      }
      if (ageStr) {
        addStandards += `年限：${ageStr}`
      }

      //解析回收条码 barcodes
      let barcodeList = []
      item.tblRecycleBarcode.forEach(barcodeItem => {
        barcodeList.push(barcodeItem.barcodeNum)
      })
      item.barcodes = barcodeList.join('、')
      //解析规格字段 standards
      let standards = ''
      item.tblRecycleStandards.forEach(item => {
        switch (item.standardsKey) {
          case 'brandName':
            item.standardsKeyStr = '品牌'
            standards = item.standardsValue ? standards + item.standardsKeyStr + '：' + item.standardsValue + '  ；' : standards
            break
          case 'xlmc':
            item.standardsKeyStr = '规格'
            standards = item.standardsValue ? standards + item.standardsKeyStr + '：' + item.standardsValue + '  ；' : standards
            break
          case 'xhmc':
            item.standardsKeyStr = '型号'
            standards = item.standardsValue ? standards + item.standardsKeyStr + '：' + item.standardsValue + '  ；' : standards
            item.xhmc = item.standardsValue
            break
        }
      })
      item.standards = standards + addStandards

      // 修复tblRecycleStandards数组处理逻辑
      item.tblRecycleStandards.forEach(stdItem => {
        if (stdItem.standardsKeyStr === '型号') {
          item.xhmc = stdItem.standardsValue
        } else if (stdItem.standardsKeyStr === '品牌') {
          item.brand = stdItem.standardsValue
        } else if (stdItem.standardsKeyStr === '规格') {
          item.specs = stdItem.standardsValue
        }
      })

      console.log('item', item)
      return item
    },
    // 实收规格：订单实际回收的型号与规格
    formatActualStandards() {
      const parts = []
      if (this.orderInfo.actualXhmc) parts.push('型号：' + this.orderInfo.actualXhmc)
      if (this.orderInfo.actualXlmc) parts.push('规格：' + this.orderInfo.actualXlmc)
      return parts.length > 0 ? parts.join('；') + '；' : ''
    },
    // 处理有http图片地址
    async transImgUrl(imgUrl, propName) {
      if (imgUrl && propName) {
        // 直接使用 URL，不再通过 Canvas 转换，避免 CORS 导致的 SecurityError
        this.$set(this, propName, imgUrl)
      }
    },

    convertUrlToBase64(url) {
      return new Promise(resolve => {
        let img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = url
        img.onload = function () {
          let canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, img.width, img.height)
          let ext = img.src.substring(img.src.lastIndexOf('.') + 1).toLowerCase()
          let dataURL = canvas.toDataURL('image/' + ext)
          let base64 = {
            dataURL: dataURL,
            type: 'image/' + ext,
            ext: ext
          }
          resolve(dataURL)
        }
      })
    },
    // 处理没有http图片地址
    async handleImgUrl(imgUrl, propName) {
      if (imgUrl && propName) {
        try {
          const imgVal = await this.axios({
            url: process.env.BASE_API + `/autoapp-default-server-recovery/api/OSS/generatePresignedUrl?objectName=${imgUrl}`,
            method: 'GET',
            headers: {
              // 设置请求头
              Authorization: this.$store.getters.token
            }
          }).then(res => {
            // res.request.responseURL 通常是重定向后的最终地址（如 OSS 签名地址）
            return res.request.responseURL || (res.data && res.data.url) || res.config.url
          })

          this.$set(this, propName, imgVal)
        } catch (error) {
          console.error(`加载图片失败: ${imgUrl}`, error)
        }
      }
    },

    async uploadSuccess(val, flag) {
      console.log('走到了这里', val, flag)
      this.$set(this.orderInfo, flag, val)
      if (flag == 'productImage') {
        // this.productImageBase64 = null;
        this.handleImgUrl(val, 'productImageBase64')
      }
      if (flag == 'productImageSide') {
        this.handleImgUrl(val, 'productImageSideBase64')
      }
      if (flag == 'paymentReceiptImage') {
        this.handleImgUrl(val, 'paymentReceiptImageBase64')
      }
    },
    //订单来源处理
    filterSourceName({ businessType, sourceName }) {
      if (businessType === 2) {
        return '格力以旧换新'
      } else {
        return sourceName || '明珠绿环回收'
      }
    },
    // 推荐类型转换
    filterRecommendType(recommendType) {
      const referralTypeList = [
        {
          referralTypeId: 1,
          referralTypeName: '门店导购'
        },
        {
          referralTypeId: 2,
          referralTypeName: '小区物业'
        },
        {
          referralTypeId: 3,
          referralTypeName: '普通用户'
        }
      ]
      const itemObj = referralTypeList.find(item => item.referralTypeId == recommendType)
      return itemObj ? itemObj.referralTypeName : recommendType
    },

    // 添加取消类型转换方法
    filterCancelType(cancelType) {
      const cancelTypeList = [
        {
          value: 1,
          label: '用户取消'
        },
        {
          value: 2,
          label: '合作方取消'
        },
        {
          value: 3,
          label: '平台取消'
        }
      ]
      const itemObj = cancelTypeList.find(item => item.value == cancelType)
      return itemObj ? itemObj.label : cancelType
    },
    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    togglePhoneVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'phone':
          if (this.dataVisible.phone && this.phone.message) {
            this.getSourceOrigin(this.phone).then(res => {
              this.$set(this.phoneDetail, 'phone', res)
            })
          } else if (!this.dataVisible.phone) {
            // 还原为原始脱敏数据
            this.$set(this.phoneDetail, 'phone', this.originPhone.phone)
          }
          break
        case 'yddhPhone':
          if (this.dataVisible.yddhPhone && this.yddhPhone.message) {
            this.getSourceOrigin(this.yddhPhone).then(res => {
              this.$set(this.orderInfo, 'yddh', res)
            })
          } else if (!this.dataVisible.yddhPhone) {
            // 还原为原始脱敏数据
            this.$set(this.orderInfo, 'yddh', this.originInfo.yddh)
          }
          break
        case 'recycleRenPhone':
          if (this.dataVisible.recycleRenPhone && this.recycleRenPhone.message && this.copytblRecyleWorkOrder && this.tblRecycleWorkOrder.length > 0) {
            this.getSourceOrigin(this.recycleRenPhone).then(res => {
              this.$set(this.tblRecycleWorkOrder[0], 'recycleRenPhone', res)
            })
          } else if (!this.dataVisible.recycleRenPhone) {
            //复制数组内容
            this.tblRecycleWorkOrder = JSON.parse(JSON.stringify(this.copytblRecyleWorkOrder))
          }
          break
        case 'dizi':
          if (this.dataVisible.dizi && this.dizi.message) {
            this.getSourceOrigin(this.dizi).then(res => {
              this.$set(
                this,
                'address',
                [this.orderInfo.sfen, this.orderInfo.cshi, this.orderInfo.xian, this.orderInfo.xzhen, this.orderInfo.mapAddress, res].filter(Boolean).join('')
              )
            })
          } else if (!this.dataVisible.dizi) {
            // 还原为原始脱敏数据
            this.$set(
              this,
              'address',
              [this.orderInfo.sfen, this.orderInfo.cshi, this.orderInfo.xian, this.orderInfo.xzhen, this.orderInfo.mapAddress, this.orderInfo.dizi].filter(Boolean).join('')
            )
          }
          break
      }
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  font-weight: bold;
  font-size: 18px;
  margin-left: 30px;
}

.complete-time {
  margin-right: 100px;
}

.content {
  margin: 30px;

  div {
    margin: 16px 0;
  }
}

.button-row {
  width: 920px;
  display: flex;
  justify-content: flex-end;
}

.table {
  margin-left: 30px;
  padding-top: 10px;
}

.dialog-body {
  margin-left: 70px;
}

.dialog-footer {
  padding: 15px;
}

.btnBack {
  margin-left: 30px;
}

.row-flex {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/views/order/orderEdit.vue